import React from 'react';
import PropTypes from 'prop-types';
import { withScope, captureException } from '@sentry/browser';
import Error from './Error';

class ErrorBoundary extends React.PureComponent {
    constructor(props) {
        super(props);

        this.state = {
            hasError: false,
        };
    }

    static getDerivedStateFromError() {
        return { hasError: true };
    }

    componentDidCatch(error, errorInfo) {
        withScope((scope) => {
            Object.keys(errorInfo).forEach((key) => {
                scope.setExtra(key, errorInfo[key]);
            });
            captureException(error);
        });
    }

    render() {
        const { children, fallback } = this.props;
        const { hasError } = this.state;

        if (hasError) {
            return fallback;
        }

        return children;
    }
}

ErrorBoundary.propTypes = {
    children: PropTypes.node.isRequired,
    fallback: PropTypes.node,
};

ErrorBoundary.defaultProps = {
    fallback: <Error />,
};

export default ErrorBoundary;
